export default function Navbar() {
  return (
    <div className=' text-center w-full header bg-violet-600 py-4  text-white font-bold text-lg shadow-lg'>
      Simple Todo Application with Redux
    </div>
  );
}
